import type { Contact } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { query } from '@warp-drive/utilities/json-api';

import { filterRegex, page, sort } from '../../json-api.ts';

/**
 * Query contacts with search filters
 * @param firstname - Search text for firstname
 * @param lastname - Search text for lastname
 * @param organisation - Search text for organisation
 * @param offset - Offset for pagination
 * @param limit - Limit for pagination
 * @returns JSON API request to query contacts
 */
export function queryContacts(
  firstname: string = '',
  lastname: string = '',
  organisation: string = '',
  offset: number = 0,
  limit: number = 30
) {
  const params: Record<string, string | number> = {
    ...page({ offset, limit }),
    ...sort('-modified'),
  };

  // Apply individual filters for each field
  if (firstname) {
    Object.assign(params, filterRegex('filter[firstname]', firstname));
  }

  if (lastname) {
    Object.assign(params, filterRegex('filter[lastname]', lastname));
  }

  if (organisation) {
    Object.assign(params, filterRegex('filter[organisation]', organisation));
  }

  return query<Contact>(DataTypeContent.Contact, params, jsonApiOptions);
}
